<template>
    <div>
        <sys-pop-over-config-base :model="baseModel" :configs="noConfigs">
            <template v-slot:notice>
                <sys-notice-config-moved card="Integração Totvs" />
            </template>
        </sys-pop-over-config-base>
    </div>
</template>

<script>

export default {
    name: "SysInstitutionPopOverSetting",
    // O ConfigBase exige model/configs; aqui só o aviso é exibido (valores estáveis para não disparar o watcher)
    data: () => ({
        baseModel: { id: true },
        noConfigs: [],
    }),
    props: {
        institution: {
            type: Object,
            required: true,
        },
    },
}
</script>
